/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import _get from "lodash/get";
import eventContractTranslations from "./eventContractTranslations";
import membershipContractTranslations from "./membershipContractTranslations";
import otherContractTranslations from "./otherContractTranslations";
import providerContractTranslations from "./providerContractTranslations";
import purchaseContractTranslations from "./purchaseContractTranslations";
import serviceContractTranslations from "./serviceContractTranslations";
import subscriptionContractTranslations from "./subscriptionContractTranslations";
import travelContractTranslations from "./travelContractTranslations";
import vehicleContractTranslations from "./vehicleContractTranslations";
import familyLawCaseTranslations from "./familyLawCaseTranslations";
import settlementTranslations from "./settlementTranslations";
import divorceTranslations from "./divorceTranslations";
import personTranslations from "./personTranslations";
import addressTranslations from "./addressTranslations";
import caseInsuranceTranslations from "./caseInsuranceTranslations";
import trafficTranslations from "./trafficTranslations";
import abstractCaseTranslations from "./abstractCaseTranslations";
import alimonyTranslations from "./alimonyTranslations";
import processCostSupportTranslations from "./processCostSupportTranslations";
import messagingTranslations from "./messagingTranslations";
import preleadTranslations from "./preleadTranslations";
import dataLeakContractTranslations from "./dataLeakContractTranslations";
import rentalContractTranslations from "./rentalContractTranslations";
import trafficAccidentTranslations from "./trafficAccidentTranslations";
import generalCivilLawTranslations from "./generalCivilLawTranslations";
import employmentContractTranslations from "./employmentContractTranslations";
import civilServiceLawTranslations from "./civilServiceLawTranslations";
import pendingCaseTranslations from "./pendingCaseTranslations";

const translations = {
  ...abstractCaseTranslations,
  alimony: alimonyTranslations,
  civilServiceLaw: civilServiceLawTranslations,
  divorce: divorceTranslations,
  death: { label: "Tod und Erbe" },
  familyLawCase: familyLawCaseTranslations,
  generalCivilLaw: generalCivilLawTranslations,
  settlement: settlementTranslations,
  traffic: trafficTranslations,
  trafficAccident: trafficAccidentTranslations,
  employmentContract: employmentContractTranslations,
  eventContract: eventContractTranslations,
  membershipContract: membershipContractTranslations,
  otherContract: otherContractTranslations,
  providerContract: providerContractTranslations,
  pendingCase: pendingCaseTranslations,
  dataLeakContract: dataLeakContractTranslations,
  purchaseContract: purchaseContractTranslations,
  serviceContract: serviceContractTranslations,
  subscriptionContract: subscriptionContractTranslations,
  travelContract: travelContractTranslations,
  vehicleContract: vehicleContractTranslations,
  rentalContract: rentalContractTranslations,
  person: personTranslations,
  address: addressTranslations,
  caseInsurance: caseInsuranceTranslations,
  processCostSupport: processCostSupportTranslations,
  policyHolderType: {
    familyMember: "Mitversichert",
    me: "Selbst versichert",
  },
  inquiryToCustomer: {
    inquiryType: {
      options: {
        appointment: { label: "telefonische Rücksprache" },
        information: { label: "Informationen" },
        link: { label: "Informationen" },
        documents: { label: "Dokumente" },
        informationAndDocuments: { label: "Informationen und Dokumente" },
        decision: { label: "Informationen" },
      },
    },
  },
  externalLawyerApplication: {
    legalFieldExperience: {
      options: {
        contractLaw: { label: "Vertragsrecht" },
        familyLaw: { label: "Familienrecht" },
        trafficLaw: { label: "Verkehrsrecht" },
        employmentLaw: { label: "Arbeitsrecht" },
        tenancyLaw: { label: "Mietrecht" },
      },
    },
    taskType: {
      options: {
        legalDocuments: { label: "Schriftsätze fertigen (Außergerichtliche Schreiben, Klageschriften etc.)" },
        checkCases: { label: "Ermittlungsakten prüfen (z.B. im Verkehrsrecht)" },
        investigationFiles: { label: "Schriftsätze fertigen (Außergerichtliche Schreiben, Klageschriften etc.)" },
      },
    },
  },
  prelead: preleadTranslations,
  messaging: messagingTranslations,
};

export default translations;

export const translate = (path: string, caseData: Record<string, any>, defaultValue?: string | null): string => {
  const translationResult = _get(translations, path, defaultValue);
  const todoNoticeString = "TODO:" + path;

  if (translationResult === undefined || translationResult === null) {
    return todoNoticeString;
  }
  if (typeof translationResult === "function") {
    return translationResult(caseData);
  }
  if (typeof translationResult === "object") {
    return todoNoticeString;
  }
  return translationResult;
};

function translationExists(path: string) {
  return !(_get(translations, path) === undefined || _get(translations, path) === null);
}

export function translateCaseValue(caseData: any, fieldPath: string) {
  return translate(`${caseData.name}.${fieldPath}.options.${_get(caseData, fieldPath)}.label`, caseData, _get(caseData, fieldPath));
}

export function translateHelperTextIfExists(caseData: any, fieldPath: string) {
  return translationExists(`${caseData.name}.${fieldPath}.helperText`) ? translate(`${caseData.name}.${fieldPath}.helperText`, caseData) : null;
}
